import './index.scss';
import React, { useState } from 'react';
import { copyToClipboard } from '~/utils/copyToClipboard';
import { useContentLibrary } from '../../../../providers/content_library_provider';
const CopyTextButton = ({ clause }) => {
    const { activeClause } = useContentLibrary();
    const isActiveClause = activeClause && clause.id === activeClause.id;
    const [copiedId, setCopiedId] = useState('');
    const copyContent = (id, value) => {
        setCopiedId(id);
        copyToClipboard(value);
        setTimeout(() => setCopiedId(''), 1500);
    };
    return (React.createElement("div", { className: 'result-copy-text-button' },
        React.createElement("span", { "data-testid": 'copy-clause-text-button', className: `copy-text ${isActiveClause && copiedId !== clause.id ? ' visible' : ''}`, onClick: () => copyContent(clause.id, clause.source.clauseText), title: 'Copy Clause text to clipboard' },
            React.createElement("span", { className: 'fa-lg far fa-copy copy-icon' }),
            "Copy text")));
};
export default CopyTextButton;
